export default "__VITE_ASSET__BBOZ0Sxy__"